import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import type { ClientIncomeDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const mapIncomeDto = (
	dto: ClientIncomeDetailResponseDTO,
): FinanceState["income"][number] => ({
	id: dto.id,
	name: dto.name ?? "",
	amount: dto.amount,
});
